import { render } from "./Describe.vue?vue&type=template&id=19a39999&scoped=true"
import script from "./Describe.vue?vue&type=script&lang=js"
export * from "./Describe.vue?vue&type=script&lang=js"

import "./Describe.vue?vue&type=style&index=0&id=19a39999&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19a39999"]])

export default __exports__